const o = "Färgfält, nuvarande färg är {color}", r = "Color field", l = "Colors palette", e = "Förinställda färger", t = "Custom preset colors", s = "Add color", c = "Rensa färg", a = "Custom color, HEX format", n = "Lägg till färg i listan över anpassade färger", C = "Rensa fält för anpassad färg", d = "Delete color with backspace", i = {
  currentColor: o,
  emptyColor: r,
  palette: l,
  presetColors: e,
  customColors: t,
  addColor: s,
  clearColor: c,
  colorField: a,
  colorFieldConfirm: n,
  colorFieldClear: C,
  deleteColorDescriber: d
};
export {
  s as addColor,
  c as clearColor,
  a as colorField,
  C as colorFieldClear,
  n as colorFieldConfirm,
  o as currentColor,
  t as customColors,
  i as default,
  d as deleteColorDescriber,
  r as emptyColor,
  l as palette,
  e as presetColors
};
